// API versions
const version = {
  v1: 'v1',
  v2: 'v2'
};

export const endpoints = {
  visitor: {
    createVisitorProfile: (id) => `${version.v2}/visitor/complete/profile/${id}`,
    createAppointment: (buildingId) => `${version.v2}/visitor/appointment?buildingId=${buildingId}`,
    hostSearch: (name) => `${version.v2}/visitor/host-search?name=${name}`,
  }
}; 